var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      class: `anchor ${_vm.linkColor}`,
      staticStyle: {
        "margin-inline-start": "var(--anchor-margin-inline-start, -2.625em)",
      },
      attrs: { href: _vm.anchor },
    },
    [
      _c("font-awesome-icon", {
        attrs: { icon: _vm.$v7.solid.faLinkHorizontal, size: "xl" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [
        _vm._v("Link to " + _vm._s(_vm.anchorName) + " on this page"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }